const SCROLL_ANIMATION_TRIGGER_CLASSNAME = "scroll-trigger";
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = "scroll-trigger--offscreen";
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = "animate--zoom-in";
const SCROLL_ANIMATION_CANCEL_CLASSNAME = "scroll-trigger--cancel";

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;

      if (
        elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)
      ) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute("data-cascade"))
          elementTarget.setAttribute("style", `--animation-order: ${index};`);
      }

      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(
    rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
  );

  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add("scroll-trigger--design-mode");
    });

    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: "0px 0px -50px 0px",
  });

  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const animationTriggerElements = Array.from(
    document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME)
  );

  if (animationTriggerElements.length === 0) return;

  animationTriggerElements.forEach((element) => {
    let isVisible = false;

    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => (isVisible = entry.isIntersecting));
    });

    observer.observe(element);

    window.addEventListener(
      "scroll",
      throttle(() => zoomAnimation(element, isVisible)),
      { passive: true }
    );
  });
}

function zoomAnimation(element, isVisible) {
  const mediaContent = element.closest(".js-media-content");
  if (!mediaContent) return;

  const wrapper = mediaContent.querySelector(".scroll-trigger");
  if (!wrapper) return;

  const header = document.querySelector("body");
  const bars = mediaContent.querySelectorAll(".js-bar");
  const contentBlocks = mediaContent.querySelectorAll(".js-content-block");

  if (!isVisible) return resetState(contentBlocks, bars);

  const wrapperHeight = wrapper.offsetHeight;
  const elementHeight = element.offsetHeight;
  const headerHeight = parseFloat(
    header.style.getPropertyValue("--header-position").replace("px", "")
  ) || 0;
  const scrollTop = window.scrollY - mediaContent.offsetTop;
  const scrollDistance = wrapperHeight - elementHeight - headerHeight;
  const elementRect = element.getBoundingClientRect();
  const speedModifier = 0.4;

  if (scrollDistance <= 0) return;

  let percentage = scrollTop / (scrollDistance * speedModifier);

  percentage = Math.max(0, Math.min(percentage, 1));

  const sectionPadding = 1 - percentage;

  if (elementRect.top < headerHeight || elementRect.bottom > window.innerHeight) return;

  setState(contentBlocks, bars, percentage, sectionPadding);
}

function resetState(contentBlocks, bars) {
  const currentScroll = window.scrollY;
  const isScrollingDown = currentScroll > (window.lastScroll || 0);

  window.lastScroll = currentScroll;

  contentBlocks.forEach((item) => {
    item.style.transform = isScrollingDown
      ? "translate3d(0, 100%, 0)"
      : "translate3d(0, 0, 0)";
    item.style.opacity = isScrollingDown ? "0" : "1";
  });

  bars.forEach((bar) => {
    const transform = isScrollingDown
      ? (bar.classList.contains("js-bar-horizontal") ? "1, 1" : "1, 1")
      : (bar.classList.contains("js-bar-horizontal") ? "1, 0" : "0, 1");
    bar.style.transform = `scale(${transform}) translate3d(0, 0, 0)`;
  });
}

function setState(contentBlocks, bars, percentage, sectionPadding) {
  contentBlocks.forEach((item) => {
    item.style.transform = `translate3d(0, ${sectionPadding * 100}%, 0)`;
    item.style.opacity = `${percentage}`;
  });

  bars.forEach((bar) => {
    const transform = bar.classList.contains("js-bar-horizontal")
      ? `1, ${sectionPadding}`
      : `${sectionPadding}, 1`;

    bar.style.transform = `scale(${transform}) translate3d(0, 0, 0)`;
  });
}

window.addEventListener("DOMContentLoaded", () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) =>
    initializeScrollAnimationTrigger(event.target, true)
  );

  document.addEventListener("shopify:section:reorder", () =>
    initializeScrollAnimationTrigger(document, true)
  );
}
